import { render, staticRenderFns } from "./DialogAppointment.vue?vue&type=template&id=3bb82183"
import script from "./DialogAppointment.vue?vue&type=script&lang=js"
export * from "./DialogAppointment.vue?vue&type=script&lang=js"
import style0 from "./DialogAppointment.vue?vue&type=style&index=0&id=3bb82183&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports